export const errors = {
  main: 'Произошла ошибка, попробуйте снова',
}
